import { render, staticRenderFns } from "./ComponentComparison.vue?vue&type=template&id=266db7bf&scoped=true&"
import script from "./ComponentComparison.vue?vue&type=script&lang=js&"
export * from "./ComponentComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266db7bf",
  null
  
)

export default component.exports